import { IOfferAddressProps } from '../../components/OfferCard/Address';
import { IOfferAddress } from '../../types/offers';

export const getAddress = (address: IOfferAddress, isLast: boolean, domain = 'cian.ru'): IOfferAddressProps => ({
  id: address.id ?? undefined,
  title: `${address.title}${isLast ? '' : ',\u00A0'}`,
  searchUrl: address.qs ? `https://${domain}/cat.php?${address.qs}` : '',
});
